import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PanelSubHeading from "../../components/panel/subHeading";
import ProgressBar from "./charts/progressBar";

const SalePlanNoCalcDiagram = (props: {
  enableSettings: boolean;
  month: number;
  year: number;
  fact: number;
  plan: number;
  title: string;
  onOpenModal?: (...args: any) => void
}) => {

  // Получаем текущий месяц и год
  const today = new Date();
  const monthNames = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ];
  const currentMonth = monthNames[props.month]; // Название текущего месяца
  const currentYear = props.year; // Текущий год

  return (
    <div
      className="panel eventListPanel"
      style={
        !props.enableSettings
          ? {
              width: "calc(100% - 32px)",
            }
          : {
              width: "100%",
              marginBottom: 16,
            }
      }
    >
      <div className="inner">
        <div className="flex between w100">
          <PanelSubHeading text={props.title} />
          {props.onOpenModal && (
            <div className="panelBtnContainer">
              <div className="btn panelActionBtn" onClick={props.onOpenModal}>Настроить план продаж</div>
            </div>
          )}
        </div>
        <div className="toDoHeadingBorder" style={{ marginTop: 6 }} />
        <div className="inner">
          <div className="flex between">
            <div className="text">
              {` Общая цель - ${props.plan.toLocaleString("ru-RU")} $`}
            </div>
            <div className="eventDateInfo">
              План на период - {currentMonth} {currentYear}
            </div>
          </div>
          <ProgressBar
            fact={props.fact}
            target={props.plan}
            startDate={`1 ${currentMonth.toLowerCase()}`}
            endDate={`${new Date(
              today.getFullYear(),
              today.getMonth() + 1,
              0
            ).getDate()} ${currentMonth.toLowerCase()}`}
          />
        </div>
      </div>
    </div>
  );
};

export default SalePlanNoCalcDiagram;
